export default __webpack_public_path__ + "static/media/Revenue_detailed_product.ef452436.xlsx";